import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import UpdateSalesRate from "./UpdateSalesRate";
import { useGetPurchasesQuery } from "../../../features/api/purchaseApi";
import {
  useGetSalesRatesQuery,
  useRemoveSalesRateMutation,
} from "../../../features/api/salesratemainApi";
import { MdAdd, MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import AddNewSalesRate from "./AddNewSalesRate";
import { useGetProductQuery } from "../../../features/api/productApi";

const SalesPrice = () => {
  const { data } = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const products = data?.products;

  const { data: slrate, isLoading } = useGetSalesRatesQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const salesRates = slrate?.salesRates;

  const [removeSalesRate] = useRemoveSalesRateMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeSalesRate(id);
        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    const filteredResults = salesRates?.filter((item) => {
      if (typeof item?.pro_name === "string") {
        return item?.pro_name.toLowerCase().includes(searchTerm.toLowerCase());
      }
      return false;
    });
    setSearchResults(filteredResults);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <div className="flex justify-between items-center px-12 my-4">
        <h1 className="text-xl font-bold">Sales Rate Management</h1>
        {/* <Link to={"/dashboard/add-salesrate"}>
          <MdAdd className="text-2xl text-white bg-blue-500 font-bold cursor-pointer" />
        </Link> */}
        <AddNewSalesRate />
      </div>
      <input
        type="text"
        placeholder="Search items"
        className="border ml-12 focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <div className="h-[73vh] overflow-auto max-w-sm lg:max-w-[960px] m-auto">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : salesRates?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no sales rate item
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Product</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Purchase Rate</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Sales Rate</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchTerm
                  ? searchResults
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => {
                        const proName = products?.find(
                          (pro) => pro?.id === row?.pro_name
                        );
                        const passData={row,proName}
                        return (
                          <TableRow key={row?.id}>
                            <TableCell>{i + 1}</TableCell>
                            <TableCell>{proName?.product_name}</TableCell>
                            <TableCell>{row?.unit_price}</TableCell>
                            <TableCell>{row?.sales_rate}</TableCell>
                            <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                <UpdateSalesRate passData={passData} />
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })
                  : salesRates
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => {
                        const proName = products?.find(
                          (pro) => pro?.id === row?.pro_name
                        );
                        const passData={row,proName}
                        return (
                          <TableRow key={row?.id}>
                            <TableCell>{i + 1}</TableCell>
                            <TableCell>{proName?.product_name}</TableCell>
                            <TableCell>{row?.unit_price}</TableCell>
                            <TableCell>{row?.sales_rate}</TableCell>
                            <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                <UpdateSalesRate passData={passData} />
                                <span onClick={() => handleDelete(row?.id)}>
                                  <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                                </span>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[20, 30, 50]}
              component="div"
              count={salesRates?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default SalesPrice;